import { render } from "./TheTagGroup.vue?vue&type=template&id=6560e01f&scoped=true"
import script from "./TheTagGroup.vue?vue&type=script&lang=js"
export * from "./TheTagGroup.vue?vue&type=script&lang=js"

import "./TheTagGroup.vue?vue&type=style&index=0&id=6560e01f&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/akc-mallrobot-akc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6560e01f"]])

export default __exports__